
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/applications/[applicationId]/planting-report/[plantingId]/photos",
      function () {
        return require("private-next-pages/admin/applications/[applicationId]/planting-report/[plantingId]/photos/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/applications/[applicationId]/planting-report/[plantingId]/photos"])
      });
    }
  